import type { IconProps } from "@/components/Icons/index";

/**
 * Sidebar expand/collapse icon — the Figma "enlarge contract vertical" icon
 * (`public/assets/images/figma/enlarge-contract-vertical.svg`) rotated 90° so
 * the arrows point left/right for horizontal sidebar toggling.
 */
export const SidebarToggleIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    {/* center vertical line */}
    <path d="M10 3.75V16.25" stroke="currentColor" strokeWidth="1.25" strokeLinecap="square" />
    {/* left arrow */}
    <path
      d="M5.04051 7.3411L7.71039 9.999L5.04051 12.6579M7.27293 10.00034H2.5"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="square"
    />
    {/* right arrow */}
    <path
      d="M14.9589 7.3411L12.2891 9.999L14.9589 12.6579M12.8143 10.00035H17.4994"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="square"
    />
  </svg>
);
